"use strict";

exports.__esModule = true;
exports.IconMenu = void 0;
var _react = _interopRequireWildcard(require("react"));
var _icons = require("@blueprintjs/icons");
var _core = require("@blueprintjs/core");
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var MenuContainer = _styledComponents["default"].div.withConfig({
  displayName: "IconMenu__MenuContainer",
  componentId: "sc-vo6e1t-0"
})(["& .", "{overflow-y:unset;max-height:unset !important;}"], _core.Classes.MENU);

/**
 * A simple wrapper for a popover icon menu
 */
var IconMenu = exports.IconMenu = /*#__PURE__*/function (_Component) {
  function IconMenu() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(IconMenu, _Component);
  var _proto = IconMenu.prototype;
  _proto.renderMenu = function renderMenu() {
    var _this$props = this.props,
      popoverName = _this$props.popoverName,
      children = _this$props.children;
    return /*#__PURE__*/_react["default"].createElement(MenuContainer, {
      className: popoverName
    }, children);
  };
  _proto.render = function render() {
    var _this$props2 = this.props,
      icon = _this$props2.icon,
      iconSize = _this$props2.iconSize;
    return /*#__PURE__*/_react["default"].createElement(_core.Popover
    // eslint-disable-next-line jsx-a11y/no-autofocus
    , {
      autoFocus: false,
      content: this.renderMenu(),
      interactionKind: _core.PopoverInteractionKind.CLICK,
      position: _core.Position.BOTTOM_RIGHT
    }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
      icon: icon,
      size: iconSize,
      "data-testid": "SettingsMenu.Button"
    }));
  };
  return IconMenu;
}(_react.Component);
IconMenu.defaultProps = {
  iconSize: _core.IconSize.LARGE,
  icon: _icons.IconNames.COG
};